import httpClient from './httpClient';

export const BANNER_IN_SEARCH_ENDPOINT = '/backoffice/search_suggestions';

export const getBannerInSearchListAPI = (params = {}) => httpClient.get(BANNER_IN_SEARCH_ENDPOINT, { params });
export const getBannerInSearchAPI = (id) => httpClient.get(`${BANNER_IN_SEARCH_ENDPOINT}/${id}`);
export const createBannerInSearchAPI = (body = {}) => httpClient.post(BANNER_IN_SEARCH_ENDPOINT, body);
export const updateBannerInSearchAPI = (id, body = {}) => httpClient.put(`${BANNER_IN_SEARCH_ENDPOINT}/${id}`, body);
export const deleteBannerInSearchAPI = (id) => httpClient.delete(`${BANNER_IN_SEARCH_ENDPOINT}/${id}`);